/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { Dimensions, TouchableOpacity, View } from "react-native";
import { TokenResponse, useGoogleLogin } from "@react-oauth/google";

import { useSelector } from "react-redux";
import { RootState } from "store/types";

import { TermsConditionsText, Text } from "UpduoLibrary";
import {
  skaleTextGray,
  skaleCommunityGray,
  skaleWebTextLightGray,
} from "config/UpduoColors";

const windowWidth = Dimensions.get("window").width;
const textColor = skaleTextGray;
interface GoogleViewProps {
  onGooglePress?: (response: TokenResponse) => void;
}

export default function GoogleView({ onGooglePress }: GoogleViewProps) {
  const startObject = useSelector((state: RootState) => state.startObject);

  const doGoogleLogin = useGoogleLogin({
    onSuccess: (tokenResponse: TokenResponse) =>
      onGooglePress ? onGooglePress(tokenResponse) : null,
    onError: (error) => {
      console.log("useGoogleLogin error", error);
    },
  });

  return (
    <View
      style={{
        marginHorizontal: windowWidth * 0.1,
        marginBottom: 15,
        alignItems: "center",
      }}
    >
      <Text
        style={{
          color: skaleCommunityGray,
          fontSize: 30,
          fontWeight: "bold",
          marginBottom: 15,
          textAlign: "center",
        }}
      >
        {`Please log in using your\nemail address for:\n${startObject?.name}`}
      </Text>
      <Text
        style={{
          color: textColor,
          fontSize: 16,
        }}
      >
        {`This was given to you when you first joined ${startObject?.name}.`}
      </Text>
      <TermsConditionsText />
      <View style={{ alignItems: "center", marginTop: 20 }}>
        <TouchableOpacity
          style={{
            flexDirection: "row",
            borderWidth: 1,
            borderRadius: 10,
            borderColor: skaleWebTextLightGray,
            alignItems: "center",
            paddingLeft: 10,
            paddingRight: 15,
          }}
          onPress={() => doGoogleLogin()}
        >
          <img
            src={"https://developers.google.com/identity/images/g-logo.png"}
            style={{
              width: 30,
              height: 30,
              marginRight: 10,
            }}
            alt={"google"}
          />
          <Text>{"Google Login"}</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}
